import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  initBar,
  barAnimation,
  datasetYX,
  xLinear,
  yBand,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  pivotAdapter,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotIndicatorsAsCol,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  barStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
  horizontalCrosshairRect,
  barCornerRadius,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorBarStyleFill,
  pivotColorLegend,
  barMaxWidth,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const bar: VChartSpecPipeline = [
  fontFamilyTheme,
  initBar,
  barAnimation,
  regionPadding,
  barCornerRadius,
  barMaxWidth,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetYX,
  animationMorph,
  progressive,
  xLinear,
  yBand,

  label,
  brush,
  tooltip({ titleEncoding: 'y' }),
  colorAdapter(discreteLegend, colorLegend),
  horizontalCrosshairRect,
  colorBarStyleFill(barStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
]

const pivotBar: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsCol,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initBar,
    barAnimation,
    regionPadding,
    barCornerRadius,
    barMaxWidth,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetYX,
    animationMorph,
    progressive,
    xLinear,
    pivotAxisStyle(yBand),
    label,
    brush,
    tooltip({ titleEncoding: 'y' }),
    colorBarStyleFill(barStyle),
    horizontalCrosshairRect,
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationDifferenceLine,
    annotationAreaBand,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const barSpecPipeline = [pivotAdapter(bar, pivotBar)]
